import React from 'react'

import banner from '../../assets/images/smartWatch/banner-top.png'

const BannerSmartWatch = () => {
  return (
    <div className='banner-smartWatch'>
        <a href=""><img src={banner} alt="" /></a>
    </div>
  )
}

export default BannerSmartWatch
